/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Feature_TitleInputs */

const en_mk_tb_feature_title = /** @type {(inputs: Mk_Tb_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human team collaboration`)
};

const id_mk_tb_feature_title = /** @type {(inputs: Mk_Tb_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolaborasi tim manusia`)
};

/**
* | output |
* | --- |
* | "Human team collaboration" |
*
* @param {Mk_Tb_Feature_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_feature_title = /** @type {((inputs?: Mk_Tb_Feature_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Feature_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_feature_title(inputs)
	return en_mk_tb_feature_title(inputs)
});